import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import Logo5 from '../../images/location_new/caseimg/logo5.webp';
import Img5 from '../../images/location_new/caseimg/img5.webp';
import Logo6 from '../../images/location_new/caseimg/logo6.webp';
import Img6 from '../../images/location_new/caseimg/img6.webp';
import Logo7 from '../../images/location_new/caseimg/logo7.webp';
import Img7 from '../../images/location_new/caseimg/img7.webp';
import Logo8 from '../../images/location_new/caseimg/logo8.webp';
import Img8 from '../../images/location_new/caseimg/img8.webp';
import {Case_Arrow} from '../../../app-constants';
import {Link} from 'gatsby';

const CaseStudy = [
    {
        logo: Logo5,
        title: 'The Idea Behind PicturePick',
        description:"Picture Pick's grand vision is to combine an irresistible online game with cash prizes, offering an exciting dual experience that's impossible to resist.",
        link: 'picture-pick',
        technology: {
            iOS: 'iOS',
            Android: 'Android',
        },
        Img: Img5,
        BgColor: 'rgb(215 102 55 / 20%)',
        TextColor: '#d76637'
    },
    {
        logo: Logo6,
        title: 'The Idea Behind Teemates',
        description:"Teemates simplify the process of playing & engaging with fellow golf enthusiasts, offering a seamless and convenient platform, enabling you to connect with individuals sharing similar interests.",
        link: 'teemates',
        technology: {
            iOS: 'iOS',
            Android: 'Android',
        },
        Img: Img6,
        BgColor: '#F7F7F7',
        TextColor: '#99B64B'
    },

    {
        logo: Logo7,
        title: 'The Idea Behind Stop Vaping',
        description:"Stop Vaping, a digital teen solution, promotes reducing nicotine and e-cigarette use for better health. The app motivates and offers easy paths to a healthier lifestyle.",
        link: 'stop-vaping',
        technology: {
            iOS: 'iOS',
            Android: 'Android',
        },
        Img: Img7,
        BgColor: '#66ccc14d',
        TextColor: '#febc5c'
    },


    {
        logo: Logo8,
        title: 'The Idea Behind Onsite Social',
        description:"OnSite Social, a TekRevol creation, bridges the physical and digital realms, forging meaningful real-time connections among users.",
        link: 'onsite',
        technology: {
            iOS: 'iOS',
            Android: 'Android',
        },
        Img: Img8,
        BgColor: '#f3faff',
        TextColor: '#54a4c9'
    },
];

function Stories(props) {
    return (
        <div className="section_stories p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="m-auto text-center">
                        <div className="example center text-center" data-text="Success">
                            <h2>Unveiling TekRevol’s Success Stories</h2>
                        </div>
                        <p>There are multiple success stories that come under our record for both startups and large-scale enterprises.Our unwavering commitment and passionate dedication to crafting digital products of exceptional success have driven companies to revolutionize their respective markets. As an innovative software development company in Chicago, we've collaborated with visionary entrepreneurs, sharing our enthusiasm for emerging technologies to create groundbreaking solutions that resonate with both businesses and their audiences. Now, we're delighted to extend an invitation for you to explore a showcase of these achievements.</p>
                    </Col>
                    {CaseStudy.map((item, index) => (
                        <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto" key={index}>
                            <div className="stories_item" style={{backgroundColor: item.BgColor}}>
                                <div className="item_logo">
                                    <LazyLoadImage
                                        src={item.logo}
                                        effect="blur"
                                        alt={item.title}
                                        className="img-fluid"
                                    />
                                    <ul style={{color: item.TextColor, borderColor: item.TextColor}}>
                                        <li>{item.technology.iOS}</li>
                                        <li>{item.technology.Android}</li>
                                    </ul>
                                </div>
                                <div className="item_tech">
                                    <div className="tech_content">
                                        <h4 style={{color: item.TextColor}}>{item.title}</h4>
                                        <p>{item.description}</p>

                                        <Link to={item.link ? `/case-studies/${item.link}` : 'https://www.tekrevol.com/projects'}
                                              className="case_btn"
                                              aria-label="TekRevol Contact" style={{backgroundColor: item.TextColor}}>
                                            View Case Study {Case_Arrow}
                                        </Link>
                                    </div>
                                    <div className="tech_img">
                                        <LazyLoadImage
                                            src={item.Img}
                                            effect="blur"
                                            alt={item.title}
                                            className="img-fluid"
                                        />
                                    </div>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
}

export default Stories;
